import flatpickr from "flatpickr";
import moment from 'moment';
import { Romanian } from "flatpickr/dist/l10n/ro.js";

$(document).ready(function () {
    const WEEKEND_MIN_SEATS = 10;

    let day = null;
    let seats = $('input[name="seats"]').val();
    let program = $('input[name="program"]:checked').val();
    let winery = parseInt(window.Laravel.wineryId);
    let maxSeats = parseInt(window.Laravel.maxSeats);

    var timeout;

    // add person
    $('#input_select_locuri_plus').on('click', function () {
        let i = $('#input_select_locuri');
        i.val(seats = Math.min(maxSeats, parseInt(i.val()) + 1));

        if (parseInt(i.val()) !== 0) {
            refreshAvailability();
        }
    });

    // remove person
    $('#input_select_locuri_minus').on('click', function () {
        let i = $('#input_select_locuri');
        i.val(seats = Math.max(0, parseInt(i.val()) - 1));

        if (parseInt(i.val()) !== 0) {
            refreshAvailability();
        }
    });

    $('#input_select_locuri').on('change', function () {
        seats = Math.min(parseInt($(this).val()), parseInt(maxSeats));

        refreshAvailability();
    });

    let suggestion1;
    $('#finalizare_rezervare').on('click', function () {
        incapacitateUser();
        $.get(window.Laravel.checkWineryAvailability, {
            winery: winery,
            program: program,
            month: moment(day, 'DD.MM.YYYY').format('YYYY-MM-DD'),
            seats: seats
        })
            .done(function (response) {
                if (response.is_available) {
                    window.scrollTo(0, 0);

                    suggestion1 = $('#suggestion_1').dialog({
                        modal: true,
                        autoOpen: true,
                        resizable: false,
                        draggable: false,
                    });
                } else {
                    alert("Crama indisponibila, va rugam selectati o configurare valida!");
                }
            })
            .fail(function (response) {
                alert("Crama indisponibila, va rugam selectati o configurare valida!");
            }).always(function () {
            rehabilitateUser();
        });
    });

    let suggestion2;
    $('#suggestion_1_no').on('click', function () {
        window.scrollTo(0, 0);

        suggestion1.dialog('close');
        suggestion2 = $('#suggestion_2').dialog({
            modal: true,
            autoOpen: true,
            resizable: false,
            draggable: false,
        });
    });

    $('#suggestion_1_yes').on('click', function () {
        window.scrollTo(0, 0);

        addToCart();

        window.location.href = $(this).data('href');
    });

    $('#suggestion_2_yes').on('click', function () {
        suggestion2.dialog('close');

        window.scrollTo(0, 0);

        addToCart();

        window.location.href = $(this).data('href');
    });

    $('#suggestion_2_no').on('click', addToCart)

    function addToCart() {
        incapacitateUser();

        $.post(window.Laravel.addToCartUrl,
            {
                _token: window.Laravel.csrfToken,
                productID: winery,
                quantity: 1,
                type: 'booking',
                operation: 'add',
                options: {
                    winery: winery,
                    program: program,
                    day: moment(day, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    seats: seats,
                    packet: $('input[name="packet"]:checked').val()
                }
            }
        ).done(function (data) {
            if (suggestion1 && suggestion1.hasClass('ui-dialog-content')) {
                suggestion1.dialog('close');
            }
            if (suggestion2 && suggestion2.hasClass('ui-dialog-content')) {
                suggestion2.dialog('close');
            }

            // populate modal content with new data
            $('.js-cart-content').html(data.message);

            // open modal dialog
            let dialog = $('#cart-info-modal').dialog({
                modal: true,
                autoOpen: false,
                resizable: false,
                draggable: false
            });

            dialog.dialog('open');

            let AddToCartOptions = {
                content_name: data.content.product.name,
                content_ids: [data.content.product.code],
                content_type: 'Rezervare Crama',
                value: String(data.content.price),
                currency: 'RON'
            }
            // facebook pixel event
            fbq('track', 'AddToCart', AddToCartOptions);

            ///GA4-add_to_cart
            gtag("event", "add_to_cart", {
                currency: 'RON',
                value: String(data.content.product.price - data.content.product.discount),
                items: [
                    {
                        item_id: data.content.product.code,
                        item_name: data.content.product.name,
                        discount: data.content.product.discount,
                        index: data.content.product.is_available,
                        item_category: data.content.product.category.category,
                        item_category2: data.content.product.variety,
                        item_type: data.content.product.type,
                        price: String(data.content.product.price),
                        quantity: 1
                    }
                ]
            });
            ////End GA4-add_to_cart
        }).always(function () {
            rehabilitateUser();
        });
    }

    function attachEvents() {
        createCalendar();

        // reset owl carousel
        $(".owl-carousel").owlCarousel({
            autoplay: true,
            rewind: true,
            nav: false,
            dots: true,
            navText: ["<i class='fa fa-chevron-left original'></i>",
                "<i class='fa fa-chevron-right original'></i>"],
            responsive: {
                0: {items: 1},
                600: {items: 2},
                1000: {items: 4}
            }
        });

        $('.program-input').on('change', function () {
            program = $(this).val(); // changed day
            refreshAvailability();
        });

        $('.packet-input').on('change', function () {
            resetSummary();
        });
    }

    function resetSummary() {
        let program = $('input[name="program"]:checked');
        let packet_title = $('input[name="packet"]:checked').attr('data-name');
        let no_packet = $('input[name="packet-input"]:checked').attr('data-name');

        if (packet_title) {
            $('#title_packets').text(packet_title);
        } else {
            $('#title_packets').text(no_packet);
        }

        let availabilityPrice = program.attr('data-price');
        $('#summary_program_title_seats').html(seats);
        $('#summary_availability_price').html((parseFloat(availabilityPrice) * parseInt(seats)) + ' RON');

        let packetPrice = $('input[name="packet"]:checked').attr('data-price');
        $('#summary_packet_title_seats').html(seats);
        $('#summary_packet_price').html((parseFloat(packetPrice) * parseInt(seats)) + ' RON');

        let availabilityHour = program.attr('data-hour');

        let selectedDay = moment(day, "DD.MM.YYYY");

        // show or hide free money
        let program_cashback = $('#summary_program_obs');
        program_cashback.show();
        if(selectedDay.day() === 6 || selectedDay.day() === 0) {
            program_cashback.hide();
        }

        $('#summary_date_day').html(new Intl.DateTimeFormat("ro-RO").format(selectedDay));
        $('#summary_date_hour').html(', Ora ' + availabilityHour);

        $('#summary_total').html('Total ' + ((parseFloat(availabilityPrice) + parseFloat(packetPrice)) * seats) + ' RON');
    }

    function refreshAvailability(additionalParams) {
        incapacitateUser();

        clearTimeout(timeout);
        timeout = setTimeout(function () {
            $.get(window.Laravel.resetWineryAvailability, {
                winery: winery,
                program: program,
                month:  moment(day, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                seats: seats, ...additionalParams
            })
                .done(function (response) {
                    maxSeats = response['available_seats'];
                    window.Laravel.wineryCalendar = response['calendar'];

                    seats = Math.min(Math.max(1, seats), maxSeats);
                    $('input[name="seats"]').val(seats);
                    $('#locuri_disponibile_ramase').html(maxSeats);
                    $('#winery_programs').html(response['html_programs']);
                    $('#winery_packets').html(response['html_packets']);

                    // show weekend minimum notice
                    let selectedMoment = moment(day, 'DD.MM.YYYY');
                    let isWeekend = selectedMoment.day() === 0 || selectedMoment.day() === 6;
                    if (isWeekend && seats < WEEKEND_MIN_SEATS) {
                        $('#weekend-min-notice').show();
                    } else {
                        $('#weekend-min-notice').hide();
                    }

                    // refresh day value
                    resetSummary();

                    // since html remove all events, make some workaround
                    attachEvents();
                }).always(function () {
                rehabilitateUser();
            });
        }, 0);
    }

    function incapacitateUser() {
        document.body.style.cursor = 'wait';
        $('body *').css('pointer-events', 'none');
    }

    function rehabilitateUser() {
        document.body.style.cursor = 'default';
        $('body *').css('pointer-events', '');
    }

    function createCalendar()
    {
        let defaultDate = day ? moment(day, 'DD.MM.YYYY').toDate() : new Date();
        flatpickr('#booking-calendar', {
            locale: Romanian,
            inline: true,
            enableTime: false,
            defaultDate: defaultDate,
            minDate: new Date(), // 2 days in the future
            maxDate: new Date(window.Laravel.wineryCalendarMaxDate), // 3 months in the future
            disable: [function(date) {
                const day = moment(date).format('YYYY-MM-DD');
                if (window.Laravel.wineryCalendar[day]) {
                    return window.Laravel.wineryCalendar[day]['disabled'];
                }

                return true;
            }],
            onChange: function(selectedDates, dateStr, instance) {
                day = selectedDates[0].toLocaleDateString('ro-RO');
                refreshAvailability();
            },
        });
    }

    attachEvents(); // first attack when page loaded
});